import { Link } from '../components/widgets/buttons';
import { useDialogManager } from '../components/widgets/dialog';
import { SkeletonBlock, SkeletonStack } from '../components/widgets/skeleton';
import React, { FunctionComponent } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import styled from 'styled-components';
import { docsDialogQuery } from './__generated__/docsDialogQuery.graphql';
import { ConnectShopDialog } from './connectShopDialog';

const DocsContent: FunctionComponent<{ id: string; className?: string }> = (props) => {
    const query = useLazyLoadQuery<docsDialogQuery>(
        graphql`
            query docsDialogQuery($id: ID!) {
                zendeskArticle(id: $id) {
                    title
                    body
                }
            }
        `,
        { id: `guid://Zakeke/ZendeskArticle/${props.id}` }
    );

    return <p className={props.className} dangerouslySetInnerHTML={{ __html: query.zendeskArticle?.body || '' }} />;
};

export const StyledDocsContent = styled(DocsContent)`
    font-family: ${(props) => props.theme.app.font};
    font-size: 16px;

    a {
        color: ${(props) => props.theme.app.component.link};
    }

    img {
        max-width: 100%;
        margin: auto;
        display: block;
    }

    iframe {
        margin: auto;
        display: block;
    }

    .hide-in-the-backoffice {
        display: none;
    }

    .view-in-the-backoffice {
        display: flex !important;
        justify-content: flex-end;
    }
`;

export const Loader = (
    <SkeletonStack aria-hidden='true' $gap='12px'>
        <SkeletonBlock $height='44px' $radius='10px' $margin='5px 0 24px' />
        {Array.from({ length: 20 }).map((_, idx) => (
            <SkeletonBlock key={idx} $height='18px' $radius='10px' />
        ))}
    </SkeletonStack>
);

export const ZendeskLink: FunctionComponent<{ dataTrack?: string; linkText: string; title: string; zendeskDocId?: string }> = (props) => {
    const { showDialog } = useDialogManager();

    const onClick = () => {
        if (props.zendeskDocId) {
            showDialog('docs', <ConnectShopDialog title={props.title} id={props.zendeskDocId} />);
        }
    };

    return (
        <Link
            data-track={props.dataTrack}
            onClick={() => {
                onClick();
            }}
        >
            {props.linkText}
        </Link>
    );
};
